import {InjectionToken} from "@angular/core";

export const ROOT_TRANSLATION = new InjectionToken<string>('root-translation');
